<template>
	<svg xmlns="http://www.w3.org/2000/svg" class="default" width="8.67mm" height="9.37mm" viewBox="0 0 24.57 26.56">
		<g id="Layer_2" data-name="Layer 2">
			<g id="Layer_1-2" data-name="Layer 1">
				<line x1="12.28" x2="12.28" y2="26.56" fill="none" stroke="#fff" stroke-width="1.35" />
				<line y1="13.28" x2="24.57" y2="13.28" fill="none" stroke="#fff" stroke-width="1.35" />
			</g>
		</g>
	</svg>
</template>
